import React , {Component} from 'react';
import {
    Page  , Link , Actions , ActionsGroup , ActionsLabel , ActionsButton , Popup , Navbar , NavRight
} from 'framework7-react';
import NumberFormat from 'react-number-format';

import { connect } from "react-redux";
import {
    toolbar
} from "../actions";
import * as axios from "axios/index";
import validator from "validator";
import Loading from "../Loader/Loading";
import * as vars from './Vars';

class Invoice extends Component{


    onPageBeforeIn(){
        this.props.toolbar(false)
    }

    constructor(props){
        super(props)
        this.state = {
            errors : {} ,

            fields : {
                creditUse : false ,
                discountCode : '' ,
                description : "" ,
            },
            requestInPageLoading : false,
            modal : {
                modalMessageShow : false ,
                modalMessageBody : "" ,
                modalMessageTitle : "" ,
            } ,

            requestError : false ,

            discountCode : [] ,

            addDescriptionModal : false ,
        }
    }


    handleModalClose(){
        this.setState({
            modal : {
                modalMessageShow : false ,
            }
        })
    }

    handleValidation(callback){
        let { fields } = this.state
        let errors = {}
        let formIsValid = true
        if (validator.isEmpty(fields.discountCode))
        {
            formIsValid = false;
            errors['discountCode'] = 'کد تخفیف را وارد کنید';
        }

        this.setState({errors} , () => {
            return callback(formIsValid)
        })
    }




    handleOrderSubmit(event){
        event.preventDefault()

        this.setState({
            requestInPageLoading : true
        })

        const foods = [];
        this.props.cart.forEach(function (count , id) {
            foods.push({
                ID : id ,
                count : count
            })
        })

        console.log(1)

        let data = new FormData()

        // data.append('user_app_version' , '100' )

        data.append('app' , localStorage.getItem('web-application') )
        data.append('users_orders_foods' , JSON.stringify({foods : foods}) )
        data.append('imei_code' , localStorage.getItem('imeiCode') )
        data.append('users_ID' , localStorage.getItem('users_ID') )
        data.append('branchs_ID' , this.props.branch.ID )
        data.append('users_address_ID' , JSON.parse(localStorage.getItem('selectedDelivery')).ID )
        data.append('allow_use_credit' , this.state.fields.creditUse ? "1" : "0" )
        data.append('pay_type' , "-1" )
        data.append('comment' ,this.state.fields.description )
        data.append('discounts_code' ,this.state.fields.discountCode )
        data.append('bank_select' , "1")
        data.append('add_from' , "webapp")





        axios.post( vars.PreUrl +  'https://www.lavefood.com/v1/orders/add' ,
            data )


            .then(response => {

                console.log(response.data)
                let data = response.data.result[0]
                console.log(data)
                if (data.error === 0)
                {
                    if (data.url_online_pay !== ""){
                        console.log("dargaah")
                        window.location = data.url_online_pay
                        // this.$f7router.navigate(data.url_online_pay)
                    }
                    else{
                        this.$f7router.navigate('/tracking/' + data.ordered_code + "/")
                        return
                    }
                }
                else{
                    this.setState({
                        requestInPageLoading : false ,
                        modal : {
                            modalMessageShow : true ,
                            modalMessageBody :  data.error_body ,
                            modalMessageTitle : "خطا" ,


                        },
                        requestError : true
                    })
                }


                this.setState({
                    requestInPageLoading : false
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({
                    requestInPageLoading : false ,
                    modal : {
                        modalMessageShow : true ,
                        modalMessageBody :  "مشکلی پیش آمده. لطفا مجددا تلاش کنید",
                        modalMessageTitle : "خطا" ,


                    },
                    requestError : true
                })
            })
    }




    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        this.setState({fields})
    }

    componentWillMount() {
        if (this.props.branch.length === 0)
            this.$f7router.navigate('/')


       if (localStorage.getItem('creditUse') !== undefined && localStorage.getItem('creditUse') !== null)
       {
           this.setState({
               fields : {
                   ...this.state.fields ,
                   creditUse : localStorage.getItem('creditUse')
               }
           })
       }
        if (localStorage.getItem('discountCodeString') !== undefined && localStorage.getItem('discountCodeString') !== null)
        {
            this.setState({
                fields : {
                    ...this.state.fields ,
                    discountCode : localStorage.getItem('discountCodeString')
                } ,
                discountCode : JSON.parse(localStorage.getItem('selectedDelivery'))
            })
        }
    }



    componentDidMount(){
        if (this.props.branch.length === 0)
        {
            this.$f7router.navigate('/')
            return false
        }
    }



    render(){
        const { products, cart, branch  } = this.props
        const {errors} = this.state



        let cartCount = 0
        cart.forEach(function ( item ) {
            cartCount += item
        })

        let maxBranchDiscount = 0
        if (branch.length !== 0)
        {
            branch.discounts.map((item , index)=> {
                if (parseInt(item.percent_branchs) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_branchs)
                }
                if (parseInt(item.percent_app) > maxBranchDiscount)
                {
                    maxBranchDiscount = parseInt(item.percent_app)
                }
            })
        }

        let totalPrice = 0
        let totalDiscount = 0
        cart.forEach( function(count , id){
                totalPrice += products[id]["price"] * count
                totalDiscount += products[id]["price"] * count * products[id]["food_discount"] / 100
            }
        )

        totalDiscount =  Math.round(totalDiscount + ( (totalPrice - totalDiscount)  * maxBranchDiscount / 100))


        let taxPrice =  Math.round(totalPrice * branch.tax / 100)
        let payablePrice = totalPrice - totalDiscount + taxPrice + parseInt(JSON.parse(localStorage.getItem('selectedDelivery')).price)


        if (this.state.discountCode.length !== 0)
        {
            let discountCode = this.state.discountCode
            let discountCodePrice = 0
            console.log(discountCode)
            if(discountCode.percent_code > 0)
            {
                discountCodePrice =   Math.round(discountCode.percent_code * payablePrice / 100)
                if (discountCode.max_price > 0 && discountCodePrice > discountCode.max_price)
                {
                    discountCodePrice = discountCode.max_price
                }
            }
            else if(discountCode.price_code)
            {
                discountCodePrice = discountCode.price_code
            }
            totalDiscount += discountCodePrice

            payablePrice -=  discountCodePrice
        }


        if(this.state.fields.creditUse === true)
        {
            payablePrice -= parseInt(localStorage.getItem('usersCredit'))
        }

        if (payablePrice < 0)
            payablePrice = 0


        let priceText = (<div>
            <NumberFormat value={JSON.parse(localStorage.getItem('selectedDelivery')).price}  displayType={'text'} thousandSeparator={true}  />   تومان
        </div>)


        if (parseInt(JSON.parse(localStorage.getItem('selectedDelivery')).price) === 0)
            priceText = (
                <div>رایگان</div>
            )
        if (parseInt(JSON.parse(localStorage.getItem('selectedDelivery')).price) === -1)
            priceText = (
                <div>خارج از محدوده سرویس</div>
            )


        return(
            <Page name="Invoice" className="bg-white" onPageBeforeIn={this.onPageBeforeIn.bind(this)}>

                <div id="inner-header" >

                    <Link back id="back">
                        <img src="https://www.lavefood.com/webappassets/images/back.svg" />
                    </Link>
                    <div className="title">
                        فاکتور نهایی
                    </div>
                </div>

                <Loading show={this.state.requestInPageLoading} />

                <div id="inner-header-separator" />

                <div id="invoice">
                    <div className="item">

                        <div className="b-row justify-content-between">
                            <div className="b-col-auto">
                                <div className="title">
                                    <img className="icon" src="https://www.lavefood.com/webappassets/images/edit.svg" />
                                    سفارش نیاز به توضیح دارد؟
                                </div>
                            </div>
                            <div className="b-col-auto">
                                <div className="link-custom-1"  onClick={()=> this.setState({addDescriptionModal : true})}>
                                    + افزودن توضیح
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="item">

                        <div className="b-row justify-content-between">
                            <div className="b-col-12">
                                <div className="title">
                                    <img className="icon" src="https://www.lavefood.com/webappassets/images/location.svg" />
                                    آدرس تحویل سفارش
                                </div>
                            </div>
                        </div>

                        <div className="b-row">
                            <div className="b-col-12">
                                <div className="description mt-4">
                                    {JSON.parse(localStorage.getItem('selectedDelivery')).address}
                                </div>
                            </div>
                        </div>

                        <div className="b-row">
                            <div className="b-col-12 text-left mt-2">


                                <Link href="/address/" className="link-custom-1" >
                                    تغییر آدرس
                                </Link>

                            </div>
                        </div>

                    </div>

                    <div className="item">
                        <div className="b-row justify-content-between">
                            <div className="b-col-12">
                                <div className="title pr-0">
                                    سفارش شما
                                </div>
                            </div>
                        </div>


                        <div id="invoice-foods-container" className="mt-4">


                            {
                                cart.map((count , id)=>

                                    <div className="invoice-food" key={id}>
                                        <div className="b-row no-gutters justify-content-between align-items-center" >
                                            <div className="b-col-auto">
                                                <div className="title">
                                                    {products[id].title_fa} ({count})
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="price">
                                                    <NumberFormat value={products[id].price}  displayType={'text'} thousandSeparator={true}  />   تومان
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                )
                            }



                        </div>
                    </div>

                </div>



                {
                    cartCount > 0 ? (

                            <div id="cart-footer">
                                <div className="content">

                                    <div className="b-container b-0 ">

                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="total">
                                                    جمع کل و مالیات
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="total">
                                                    {<NumberFormat value={totalPrice} displayType={'text'} thousandSeparator={true}  />} تومان


                                                </div>
                                            </div>
                                        </div>


                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="discount">
                                                    تخفیف ویژه
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="discount">
                                                    {<NumberFormat value={totalDiscount} displayType={'text'} thousandSeparator={true}  />} تومان

                                                </div>
                                            </div>
                                        </div>

                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="delivery-price">
                                                    هزینه پیک
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="delivery-price">
                                                    {priceText}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="b-row no-gutters row-eq-height justify-content-between">
                                            <div className="b-col-auto">
                                                <div className="payable">
                                                    مبلغ کل
                                                </div>
                                            </div>
                                            <div className="b-col-auto">
                                                <div className="payable">
                                                    {<NumberFormat value={payablePrice} displayType={'text'} thousandSeparator={true}  />} تومان

                                                </div>
                                            </div>
                                        </div>



                                    </div>



                                </div>

                                <div className="btn btn-block " id="add-request" onClick={this.handleOrderSubmit.bind(this)}>
                                    پرداخت و ثبت نهایی
                                </div>
                            </div>
                        ) :
                        ( `` )
                }









                <Actions className="modal-custom-1"  ref="actionsOneGroup" opened={this.state.modal.modalMessageShow} onActionsClosed={() => this.handleModalClose(false)}>
                    <ActionsGroup>
                        <ActionsLabel>{this.state.modal.modalMessageTitle}</ActionsLabel>
                        <div className="content">
                            {this.state.modal.modalMessageBody}
                        </div>
                        <div className="footer">
                            <ActionsButton>
                                <span className="footer-close" onClick={ () => this.state.requestError ? `` : this.setState({addDescriptionModal : false}) }>
                                    خب
                                </span>
                            </ActionsButton>
                        </div>
                    </ActionsGroup>
                </Actions>


                <Popup id="discount-code-form-popup" swipeToClose opened={this.state.addDescriptionModal} onPopupClosed={() => this.setState({addDescriptionModal : false})}>
                    <Loading show={this.state.requestInPageLoading} />
                    <Page>
                        <Navbar title="افزودن توضیح">
                            <NavRight>
                                <Link popupClose>بستن</Link>
                            </NavRight>
                        </Navbar>
                        <div className="display-flex justify-content-center align-items-center h-100">

                            <div  className="input-container pt-0">



                                <label htmlFor="phone" className="label">
                                    <img src="https://www.lavefood.com/webappassets/images/edit.svg" className="img"/>
                                    <div className="title">
                                        توضیح
                                    </div>
                                </label>
                                <div className="form-group">
                                    <textarea name="description" onChange={this.handleChange.bind(this)}  className="form-control input-field" />
                                    <span className={["invalid-feedback" ,  errors['description'] ? 'd-block' : 'd-none'].join(' ')}>{ errors['description'] }</span>
                                </div>


                                <div className="input-group">
                                    <button type="submit" className="btn btn-custom-4 "  onClick={()=> this.setState({addDescriptionModal : false})}>
                                        خب
                                    </button>
                                </div>

                            </div>



                        </div>
                    </Page>
                </Popup>



            </Page>
        )
    }
}

const mapDispatchToProps = dispatch => ({


    toolbar : show => dispatch(toolbar(show)) ,


})

const mapStateToProps = state => {
    return {
        products : state.products ,
        cart : state.cart ,
        branch : state.branch ,
        toolbarShow : state.toolbar
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(Invoice);